import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import type { CarePlan, Task } from "fhir/r4";

interface CreateRecommendationParams {
  recommendationDescription: string;
}

interface CreateRecommendationResponse {
  carePlan: CarePlan;
  recommendation: Task;
}

export const useCreateRecommendation = ({
  encounterId,
  carePlanId,
}: {
  encounterId: string;
  carePlanId: string;
}) => {
  const queryClient = useQueryClient();
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApiMutation<
    CreateRecommendationResponse,
    CreateRecommendationParams
  >({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Recommendation.CREATE({
          patientId,
          encounterId,
          carePlanId,
        }),
      mutationFn: (params) => {
        return axiosInstance.post(
          `/charting/careplan/${carePlanId}/recommendation/`,
          params,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Recommendation.DEFAULT(
              {
                patientId,
                encounterId,
                carePlanId,
              },
            ),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId,
          }),
        });
      },
    },
  });
};
